
export enum AuthenticationErrorStatus {
    UserNotActive = 'User Not Active',
    UserCannotLoginViaWeb = 'User cannot login via web',
    UserCannotLoginViaMobile = 'User cannot login via Mobile',
    UserCannotLoginViaManager = 'User cannot login via Manager',
    UserCannotLoginViaClient = 'User cannot login via Client Portal',
    UserCannotLoginViaSubcontractor = 'User cannot login via Subcontractor Portal',
    TokenWasUsed = "The token is invalid"
}

export interface AuthenticationRoleResponse {
    success: boolean;
    token: string;
    roleToken?: string;
    message?: string;
    errorStatus?: AuthenticationErrorStatus;
}